import React, { useEffect, useState, useRef } from 'react'
import {Link} from 'react-router-dom'
import tmr1 from '../../images/prayer-shape/2.png'
import tmr2 from '../../images/prayer-shape/1.png'
import tmr3 from '../../images/prayer-shape/3.png'
import VideoModal from '../ModalVideo'
import './style.css'
import PageTitle from '../pagetitle'
import aboutBanner from '../../images/banners/about.webp'

const About = (props) => {
    const [currentDate, setCurrentDate] = useState('');
    const [prayerTimes, setPrayerTimes] = useState({
        fajr: '05:47',
        sunrise: '07:05',
        dhuhr: '12:34',
        asr: '15:35',
        maghrib: '17:58',
        isha: '19:15'
    });
    const [selectedLocation, setSelectedLocation] = useState('london');
    const [isLoading, setIsLoading] = useState(false);
    
    // Refs for scroll animations
    const aboutImgRef = useRef(null);
    const aboutTextRef = useRef(null);
    const timerSectionRef = useRef(null);
    const timerTextRef = useRef(null);
    const timerNumRef = useRef(null);
    
    const ukLocations = [
        { value: 'london', label: 'London' },
        { value: 'birmingham', label: 'Birmingham' },
        { value: 'manchester', label: 'Manchester' },
        { value: 'edinburgh', label: 'Edinburgh' },
        { value: 'cardiff', label: 'Cardiff' },
        { value: 'belfast', label: 'Belfast' },
        { value: 'glasgow', label: 'Glasgow' },
        { value: 'leeds', label: 'Leeds' }
    ];
    
    useEffect(() => {
        // Update current date
        const updateDate = () => {
            const date = new Date();
            const options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
            setCurrentDate(date.toLocaleDateString('en-UK', options));
        };
        
        updateDate();
        // Update date every minute
        const dateInterval = setInterval(updateDate, 60000);
        
        // Fetch prayer times for selected location
        fetchPrayerTimes(selectedLocation);
        
        // Setup IntersectionObserver for scroll animations
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                }
            });
        }, observerOptions);
        
        // Observe elements with scroll-reveal class
        const scrollElements = document.querySelectorAll('.scroll-reveal');
        scrollElements.forEach(el => {
            observer.observe(el);
        });
        
        return () => {
            clearInterval(dateInterval);
            // Cleanup observer
            scrollElements.forEach(el => observer.unobserve(el));
        };
    }, [selectedLocation]);
    
    const fetchPrayerTimes = (location) => {
        // Short loading state for visual feedback
        setIsLoading(true);
        
        // For demo purposes, we use a switch statement to simulate API responses
        // In a real implementation, this would be an actual API call
        let times;
        
        switch(location) {
            case 'birmingham':
                times = {
                    fajr: '05:52',
                    sunrise: '07:11',
                    dhuhr: '12:39',
                    asr: '15:40',
                    maghrib: '18:02',
                    isha: '19:20'
                };
                break;
            case 'manchester':
                times = {
                    fajr: '05:49',
                    sunrise: '07:08',
                    dhuhr: '12:36',
                    asr: '15:38',
                    maghrib: '18:00',
                    isha: '19:18'
                };
                break;
            case 'edinburgh':
                times = {
                    fajr: '05:42',
                    sunrise: '07:00',
                    dhuhr: '12:30',
                    asr: '15:28',
                    maghrib: '17:52',
                    isha: '19:08'
                };
                break;
            case 'cardiff':
                times = {
                    fajr: '05:55',
                    sunrise: '07:15',
                    dhuhr: '12:42',
                    asr: '15:44',
                    maghrib: '18:06',
                    isha: '19:24'
                };
                break;
            case 'belfast':
                times = {
                    fajr: '05:45',
                    sunrise: '07:03',
                    dhuhr: '12:33',
                    asr: '15:31',
                    maghrib: '17:55',
                    isha: '19:11'
                };
                break;
            case 'glasgow':
                times = {
                    fajr: '05:40',
                    sunrise: '06:58',
                    dhuhr: '12:28',
                    asr: '15:26',
                    maghrib: '17:50',
                    isha: '19:06'
                };
                break;
            case 'leeds':
                times = {
                    fajr: '05:50',
                    sunrise: '07:09',
                    dhuhr: '12:37',
                    asr: '15:39',
                    maghrib: '18:01',
                    isha: '19:19'
                };
                break;
            case 'london':
            default:
                times = {
                    fajr: '05:47',
                    sunrise: '07:05',
                    dhuhr: '12:34',
                    asr: '15:35',
                    maghrib: '17:58',
                    isha: '19:15'
                };
        }
        
        // Apply shorter delay for better user experience
        setTimeout(() => {
            setPrayerTimes(times);
            setIsLoading(false);
        }, 300);
    };
    
    const handleLocationChange = (e) => {
        const newLocation = e.target.value;
        setSelectedLocation(newLocation);
    };
    
    // If on homepage, do not render PageTitle
    return (
        <>
            {!props.isHomePage && (
                <PageTitle pageTitle={'About Us'} pagesub={'About'} backgroundImage={aboutBanner} hideText={true} />
            )}
            <div className="wpo-about-area section-padding-reduced">
            <div className="container">
                    <div className="wpo-about-wrap wpo-about-wrap-home">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                                <div className="wpo-about-img-3 scroll-reveal" ref={aboutImgRef}>
                                <img src={props.aboutImg} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 colsm-12">
                                <div className="wpo-about-text scroll-reveal" ref={aboutTextRef}>
                                <div className="wpo-section-title">
                                    <span>About Us</span>
                                        <h2>Learn the Quran with Confidence</h2>
                                </div>
                                    <p>Dar-ul-Quran Academy is a UK-based online Quran learning platform dedicated to providing high-quality Islamic education for children and adults. We offer personalised one-to-one and small-group classes led by experienced, certified tutors. Our flexible schedules, modern teaching methods and friendly environment help families across the UK learn the Quran confidently from home.</p>
                                <div className="btns">
                                        <Link to="/about" className="theme-btn" tabIndex="0">Discover More</Link>
                                        <Link to="/service" className="theme-btn btn-secondary" tabIndex="0">View Courses</Link>
                                        <Link to="/blog" className="theme-btn btn-secondary" tabIndex="0">Read Our Blog</Link>
                                        <Link to="/contact" className="theme-btn btn-secondary" tabIndex="0">Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Prayer Times Section - Start */}
                    <div className="timer-section" ref={timerSectionRef}>
                    <div className="row">
                        <div className="col-lg-5">
                                <div className="timer-text" ref={timerTextRef}>
                                <h2>Prayer Times</h2>
                                    <p>Prayer times in United Kingdom</p>
                                    <span>{currentDate}</span>
                                    <div className="location-selector">
                                        <label htmlFor="uk-location">Select Location:</label>
                                        <select 
                                            id="uk-location" 
                                            value={selectedLocation} 
                                            onChange={handleLocationChange}
                                            className="form-control"
                                        >
                                            {ukLocations.map(location => (
                                                <option key={location.value} value={location.value}>
                                                    {location.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 offset-lg-1">
                                <div className={`timer-num ${isLoading ? 'loading' : ''}`} ref={timerNumRef}>
                                    {isLoading ? (
                                        <div className="loading-spinner">
                                            <div className="spinner"></div>
                        </div>
                                    ) : (
                                        <ul>
                                            <li>Fajr<span>{prayerTimes.fajr}</span></li>
                                            <li>Sunrise<span>{prayerTimes.sunrise}</span></li>
                                            <li>Dhuhr<span>{prayerTimes.dhuhr}</span></li>
                                            <li>Asr<span>{prayerTimes.asr}</span></li>
                                            <li>Maghrib<span>{prayerTimes.maghrib}</span></li>
                                            <li>Isha'a<span>{prayerTimes.isha}</span></li>
                                </ul>
                                    )}
                                </div>
                        </div>
                    </div>
                    <div className="timer-shape1">
                        <img src={tmr1} alt="" />
                    </div>
                    <div className="timer-shape2">
                        <img src={tmr2} alt="" />
                    </div>
                    <div className="timer-shape3">
                        <img src={tmr3} alt="" />
                    </div>
                    </div>
                    {/* Prayer Times Section - End */}
                </div>
            </div>
        </>
    )
}

export default About;